import { selectOption } from './selectOption';
import { getSubTable } from './getSubTable';

export const submitInsertForm = (phpPath, formData, option, phpSubComponent) => {

    return function (dispatch) {

        fetch(phpPath, {
            method: "POST",
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    alert(data.error)
                } else {
                    dispatch({
                        type: "RESET_FORM"
                    });
                    if (phpSubComponent) {
                        dispatch(
                            getSubTable(phpSubComponent)
                        )
                    } else {
                        dispatch(
                            selectOption(option)
                        )
                    }
                }
            })
            .catch((error) => {
                dispatch({
                    type: "RESET_FORM",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/submitInsertForm.js